export const EVENT_AVATAR_AI_SIGNUP_HANDOFF_STORAGE_KEY =
  "cardsEventAvatarAiSignupHandoff";

const maxHandoffAgeMs = 24 * 60 * 60 * 1000;

const normalizeAvatarChoice = (avatar = {}) => {
  const resultUrl = avatar.resultUrl || avatar.url || "";

  if (!resultUrl) {
    return null;
  }

  return {
    resultUrl,
    jobId: avatar.jobId || "",
    themeId: avatar.themeId || "",
    label: avatar.label || avatar.themeLabel || "Avatar AI",
  };
};

export const buildEventAvatarAiSignupHandoff = ({
  sessionId = "",
  avatars = [],
  selectedJobId = "",
} = {}) => {
  const normalizedAvatars = avatars.map(normalizeAvatarChoice).filter(Boolean);
  const selectedAvatar =
    normalizedAvatars.find((avatar) => avatar.jobId === selectedJobId) ||
    normalizedAvatars[0] ||
    null;

  if (!selectedAvatar) {
    return null;
  }

  return {
    source: "event-avatar-ai",
    sessionId,
    createdAt: new Date().toISOString(),
    selectedJobId: selectedAvatar.jobId,
    selectedAvatarUrl: selectedAvatar.resultUrl,
    avatars: normalizedAvatars,
  };
};

export const saveEventAvatarAiSignupHandoff = (handoff) => {
  if (typeof window === "undefined" || !handoff) {
    return false;
  }

  try {
    window.sessionStorage.setItem(
      EVENT_AVATAR_AI_SIGNUP_HANDOFF_STORAGE_KEY,
      JSON.stringify(handoff),
    );
    return true;
  } catch {
    return false;
  }
};

const removeStoredEventAvatarAiSignupHandoff = () => {
  try {
    window.sessionStorage.removeItem(
      EVENT_AVATAR_AI_SIGNUP_HANDOFF_STORAGE_KEY,
    );
  } catch {
    // Ignore storage failures: the handoff is optional.
  }
};

export const loadEventAvatarAiSignupHandoff = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(
      EVENT_AVATAR_AI_SIGNUP_HANDOFF_STORAGE_KEY,
    );
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const createdAt = Date.parse(parsed.createdAt || "");
    if (
      !parsed.selectedAvatarUrl ||
      !Array.isArray(parsed.avatars) ||
      !createdAt ||
      Date.now() - createdAt > maxHandoffAgeMs
    ) {
      removeStoredEventAvatarAiSignupHandoff();
      return null;
    }

    return parsed;
  } catch {
    removeStoredEventAvatarAiSignupHandoff();
    return null;
  }
};

export const clearEventAvatarAiSignupHandoff = () => {
  if (typeof window === "undefined") {
    return;
  }

  removeStoredEventAvatarAiSignupHandoff();
};
